module.exports = __webpack_public_path__ + "img/about_culture.1ac997b3.png";